module.exports = {
  methods: {
    isTeacher () {
      if (JSON.parse(localStorage.getItem('session_roles'))[0].name === 'teacher') {
        return true
      } else {
        return false
      }
    },
    isAdmin () {
      if (JSON.parse(localStorage.getItem('session_roles'))[0].name === 'admin') {
        return true
      } else {
        return false
      }
    },
    isKnowledgeOnly () {
      if (JSON.parse(localStorage.getItem('session_roles'))[0].name === 'knowledge') {
        return true
      } else {
        return false
      }
    },
    moneyFormat (value) {
      if (value) {
        var parts = value.toFixed(2).toString().split('.')
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js